import {
  Box,
  Chevron,
  Div,
  H5,
  Icon,
  P,
  dateFormat,
  lightTheme,
} from '@vgrubs/components';
import { SimpleUserEntity } from 'components/src/types/user.types';
import { Link } from 'react-router-dom';

export const AgentComponent = ({ agent }: { agent: SimpleUserEntity }) => {
  return (
    <Link to={`/verifications/agent/${agent.id}`}>
      <Box $flex $between $alignCenter $mb="8">
        <Div>
          <H5 $mb="4">{agent.firstName + ' ' + agent.lastName}</H5>
          <P $color={lightTheme.lightGray} $m="0">
            Date Created: {dateFormat(agent.createdAt)}.
          </P>
        </Div>
        <Icon $rotate="90deg">
          <Chevron />
        </Icon>
      </Box>
    </Link>
  );
};
